import React from "react";
import {
  describeAttachments,
  normalizeAttachments,
} from "../../utils/commsAttachments";

const PREVIEW_MAX_CHARS = 90;

/**
 * Build the one-line preview for a chat message. Media-only messages are
 * described by kind ("Sent a photo", "Sent 3 photos") rather than generically.
 *
 * @param {Object|null} msg
 * @returns {string}
 */
export const messagePreview = (msg) => {
  const content = typeof msg?.content === "string" ? msg.content.trim() : "";
  if (!content) {
    const described = describeAttachments(normalizeAttachments(msg));
    if (!described) return "Sent an attachment";
    return /^\d/.test(described) ? `Sent ${described}` : `Sent a ${described}`;
  }
  if (content.length <= PREVIEW_MAX_CHARS) {
    return content;
  }
  return `${content.slice(0, PREVIEW_MAX_CHARS)}…`;
};

/**
 * Body of the global "new message" toast: avatar initial, sender name and a
 * one-line preview. Click handling lives on the toast itself.
 */
export default function MessageToast({ senderName, preview }) {
  const initial = (senderName || "?").trim().charAt(0).toUpperCase() || "?";
  return (
    <div className="flex items-center gap-3">
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-orange-primary text-sm font-semibold text-white">
        {initial}
      </div>
      <div className="min-w-0">
        <p className="truncate text-sm font-semibold text-gray-900">
          {senderName}
        </p>
        <p className="truncate text-sm text-gray-600">{preview}</p>
      </div>
    </div>
  );
}
